export const initAssets = ['brand/anim/skeleton.json']
export const splashAssets = [
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/15fs/skeleton.json',
  'animations/spine/15fs-sc/skeleton.json',
  'animations/spine/back/freespins/skeleton.json',
  'animations/spine/back/regular/skeleton.json',
  'animations/spine/items/back/skeleton.json',
  'animations/spine/lines/skeleton.json',
  'animations/spine/logo/freespins/skeleton.json',
  'animations/spine/logo/freespins-sc/skeleton.json',
  'animations/spine/logo/regular/skeleton.json',
  'animations/spine/reels/chance/skeleton.json',
  'animations/spine/win/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
]
export const particle = []
